import { generatePageRoute, withSingleNestedSegment } from './generatePageRoute';
import { OLD_WEB_ROUTES } from './oldWebRoutes';
import { WEB_ROUTES } from './webRoutes';

// роуты-regexp для серверной части
export const SERVER_WEB_ROUTE_MATCHERS = {
  // Лендинги
  loansRates: [generatePageRoute(WEB_ROUTES.loansRates)],
  seo: [
    generatePageRoute(WEB_ROUTES.bezPoseshhenijaBanka),
    generatePageRoute(WEB_ROUTES.obrazovanie),
    generatePageRoute(WEB_ROUTES.iphonee),
    generatePageRoute(WEB_ROUTES.nalichnymi),
  ],
  loansSeo: [
    generatePageRoute(WEB_ROUTES.loansSeoLanding),
    OLD_WEB_ROUTES.seoKreditOnlajn,
    generatePageRoute(OLD_WEB_ROUTES.oldOnlajnZayavkaNaKredit, {
      patternTransformer: withSingleNestedSegment,
    }),
  ],
  // Точная страница /kredity/onlajn-zayavka-na-kredit/ (для редиректа по skipLanding)
  onlineRequestLanding: [generatePageRoute(OLD_WEB_ROUTES.oldOnlajnZayavkaNaKredit)],
  creditCardsSeo: [
    generatePageRoute(WEB_ROUTES.creditCardsSeoLanding),
    generatePageRoute(OLD_WEB_ROUTES.oldKartyOnlajn),
    OLD_WEB_ROUTES.seoKartyOnlajn,
  ],

  banksSeo: [OLD_WEB_ROUTES.oldBankOnlajnZayavkaNaKredit],

  // Анкета
  userForm: [generatePageRoute(WEB_ROUTES.creditForm)],

  // Restore-user
  restoreUser: [WEB_ROUTES.restoreUser],

  // Whitelabel
  userFormWl: [
    generatePageRoute(WEB_ROUTES.whiteLabel),
    generatePageRoute(WEB_ROUTES.whiteLabelNew),
    generatePageRoute(OLD_WEB_ROUTES.oldWhiteLabel),
    generatePageRoute(OLD_WEB_ROUTES.oldWhiteLabelAgents),
    generatePageRoute(OLD_WEB_ROUTES.oldCreditCardsWhiteLabel),
    // Promo Whitelabel (https://sravni-corp.atlassian.net/browse/CF-5790)
    generatePageRoute(WEB_ROUTES.promoWl),
    // Partner WL (https://sravni-corp.atlassian.net/browse/CF-6356)
    generatePageRoute(WEB_ROUTES.partnerWl),
  ],

  // Выдача
  loansOffers: [
    generatePageRoute(WEB_ROUTES.loansOffers),
    generatePageRoute(OLD_WEB_ROUTES.oldPromo, {
      patternTransformer: withSingleNestedSegment,
    }),
    generatePageRoute(OLD_WEB_ROUTES.oldSend, {
      patternTransformer: withSingleNestedSegment,
    }),
    generatePageRoute(OLD_WEB_ROUTES.oldKreditOnlajn, {
      patternTransformer: withSingleNestedSegment,
    }),
    generatePageRoute(OLD_WEB_ROUTES.oldPodborOnlajnV3, {
      patternTransformer: withSingleNestedSegment,
    }),
  ],

  // Wayback
  wayback: [WEB_ROUTES.wayback, generatePageRoute(WEB_ROUTES.waybackNew)],

  // MPL
  marketplaceSeo: [generatePageRoute(WEB_ROUTES.marketplaceSeoLanding)],
  creditsFullDeal: [generatePageRoute(WEB_ROUTES.creditsFullDeal)],
  completedDeal: [WEB_ROUTES.completedDeal],

  // Фиды
  product: [WEB_ROUTES.product],
  productForm: [WEB_ROUTES.productForm],
  productStatus: [WEB_ROUTES.productStatus],
};
